import { render, staticRenderFns } from "./Practice.vue?vue&type=template&id=4a552489&scoped=true&"
import script from "./Practice.vue?vue&type=script&lang=ts&"
export * from "./Practice.vue?vue&type=script&lang=ts&"
import style0 from "./Practice.vue?vue&type=style&index=0&id=4a552489&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a552489",
  null
  
)

export default component.exports